















import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';

@Component
export default class MainPaycheckLineTemplateOverwriteEntity<Item> extends Vue {
  @PropSync('entityOverwrite', { type: Boolean, required: false, default: false }) private entityOverwriteSync!: boolean;
  @PropSync('entityId', { type: String, required: false, default: null }) private entityIdSync!: string | null;

  @Prop([ String, Function ]) private filterBy!: string | ((item: Item) => string);
  @Prop([ String, Function ]) private valueBy!: string | ((item: Item) => string);
  @Prop(Boolean) private editable!: boolean;

  @Prop() private selectableOptions!: [];

  private get source() {
    const options = this.selectableOptions.map(option => {
      return {
        value: typeof this.valueBy === 'string' ? option[this.valueBy] : this.valueBy(option),
        displayValue: typeof this.filterBy === 'string' ? option[this.filterBy] : this.filterBy(option),
      };
    });
    return [
      { value: 'no', displayValue: this.$t('no') },
      { value: 'yes', displayValue: this.$t('yes') },
      ...options,
    ];
  }

  private get selectOption() {
    if (this.entityIdSync) return this.entityIdSync;
    if (this.entityOverwriteSync) return 'yes';
    return 'no';
  }

  private set selectOption(value: string) {
    if (value === 'no') {
      this.entityOverwriteSync = false;
      this.entityIdSync = null;
    } else if (value === 'yes') {
      this.entityOverwriteSync = true;
      this.entityIdSync = null;
    } else {
      this.entityOverwriteSync = true;
      this.entityIdSync = value;
    }
  }
}
